import {useQuery, gql} from "@apollo/client";
import {useContext} from "react";
import {useLogger} from "./useLogger";
import {LocaleContext} from "../store/providers/LocaleProvider";

const QUERY = gql`
query getHomePageImage($locale: String!){
    spaWebPageCollection(locale: $locale){
        items{
            title,
            mainImage{
                title,
                url
            }
        }
    }
}`;

export const useHomepageImage = () => {
    const {localeUppercase} = useContext(LocaleContext)[0];
    const {logger} = useLogger();
    const {loading, error, data} = useQuery(QUERY, {variables: {locale: localeUppercase}, errorPolicy: "all"});
    const image = data?.spaWebPageCollection?.items?.[0];

    if (error?.message) {
        logger(error?.message, "error", "useHomepageImage", error?.stack);
    }

    return {
        image,
        loading,
        error
    };
};
